
export const roleOptions = [
    {value: "ADMIN", label: "Admin"},
    {value: "MODERATOR", label: "Moderator"},
    {value: "CUSTOMER", label: "Customer"},
]